import tw from 'tailwind-styled-components';
import styled from 'styled-components';

export const BannerWrapper = tw.div`
  bg-center
  bg-cover
  w-full
  overflow-hidden
  items-center
  flex-col
  relative
`;
BannerWrapper.displayName = 'BannerWrapper';

export const OuterContainer = tw.div`
  grid
  grid-cols-16
  relative
`;

const TWBackground = tw.div`
  md:mb-20
`;

export const Background = styled(TWBackground as any)<{ $customColor: string }>`
  margin-top: 3rem;
  border-radius: 20px;
  position: relative;
  padding-bottom: 20px;
  margin-bottom: 20px;
  overflow-x: hidden;
  z-index: -1;
  grid-column: 2 / span 14;
  ${({ $customColor }) => ($customColor ? `background-color: ${$customColor};` : '')}

  @media (min-width: 767px) {
    padding-bottom: 40px;
    margin-top: 5rem;
    grid-column: 4 / span 10;
  }
`;

export const Play = tw.span`
  sm:inset-y-1/3
  md:inset-y-1/3.2
  sm:inset-x-1/3.2
  md:inset-x-1/3.5
  absolute
  cursor-pointer
  sm:w-20
  sm:h-20
  md:w-108
  md:h-108
  z-90
`;
